import { gql } from "lib/apolloClient";
import { staffFragment, studentFragment } from "modules/CommonFragments";

export const aiFragment = {
  aiMessage: gql`
    fragment aiMessageItem on AiMessage {
      id
      role
      authorType
      content
      metadata
      createdBy {
        ...staffItem
        ...studentItem
      }
      votes {
        myVote
      }
      usageMetricsId
      parentMessage {
        id
      }
      attachments {
        id
        name
        type
        mimeType
        url
        thumbUrl
        signedUrl
        title
        metadata
        streamUrl
        parentType
        createdBy {
          id
          type
        }
        presetAttachment {
          id
        }
        modalityAttachment {
          id
          ... on ToddleDoc {
            id
            content: value
          }
          ... on ModalityFile {
            id
            content
            metadata
          }
        }
        createdAt
      }
    }
    ${staffFragment.basicStaffDetails}
    ${studentFragment.basicStudentDetails}
  `,
};
